<template>
  <div>
    <Head title="Transactions" />
    <h1 class="mb-8 text-3xl font-bold">Transactions</h1>
    <form @submit.prevent="submitSearch" class="mb-4 flex space-x-4">
      <input v-model="search.transactionId" type="text" placeholder="Transaction ID" class="border px-4 py-2 rounded" />
      <input v-model="search.orderRef" type="text" placeholder="Order Ref" class="border px-4 py-2 rounded" />
      <input v-model="search.processing_name" type="text" placeholder="Processing Name" class="border px-4 py-2 rounded" />
      <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded btn-indigo">Search</button>
    </form>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="setSort('addtime')">
            Addtime
            <span v-if="isSortedBy('addtime')">
              {{ getSortDirection('addtime') === 'asc' ? '↑' : '↓' }}
            </span>
          </th>
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="setSort('processing_id')">
            Processing
            <span v-if="isSortedBy('processing_id')">
              {{ getSortDirection('processing_id') === 'asc' ? '↑' : '↓' }}
            </span>
          </th>
          <th class="pb-4 pt-6 px-6">OrderRef</th>
          <th class="pb-4 pt-6 px-6">Transaction ID</th>
          <th class="pb-4 pt-6 px-6">Name</th>
          <th class="pb-4 pt-6 px-6">Amount</th>
          <th class="pb-4 pt-6 px-6">Param</th>
          <th class="pb-4 pt-6 px-6">Type</th>
          <th class="pb-4 pt-6 px-6">Date</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="transaction in transactions.data" :key="transaction.orderRef">
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ formatTimestamp(transaction.addtime) }}</span>
            </td>
            <td class="border-t">
              <a :href="'/transactions/?processing_id=' + transaction.processing.id" class="flex items-center px-6 py-4 focus:text-indigo-500">
                {{ getProcessingName(transaction.processing) }}
              </a>
            </td>
            <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ transaction.orderRef }}</span>
            </td>
            <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ transaction.transactionId }}</span>
            </td>
            <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ transaction.name }}</span>
            </td>
            <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ transaction.amount }}</span>
            </td>
            <td class="border-t">
                <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ decodeBase64(transaction.param) }}</span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ transaction.type }}</span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 focus:text-indigo-500">{{ formatTimestampDate(transaction.addtime) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
<!--    {{ $transactions->links() }}-->
    <pagination class="mt-6" :links="transactions.links" />
  </div>
</template>

<script>
import {Head, Link} from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import Pagination from "@/Shared/Pagination";
import SearchFilter from "@/Shared/SearchFilter";
import Layout from "@/Shared/Layout";

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    // transactions: Array,
    links: Array,
    transactions: Object,
    sortFields: Array,
    sortDirections: Array,
    processing_name: String,
    processing_id: String,
  },
  data() {
    return {
      search: {
        transactionId: '',
        orderRef: '',
        sortFields: this.sortFields || [],
        sortDirections: this.sortDirections || [],
        processing_id: this.processing_id || '',
        processing_name: this.processing_name || '',
      }
    }
  },
  methods: {
    decodeBase64(input) {
      try {
        return atob(input);
      } catch (e) {
        return input;
      }
    },
    mounted() {
      console.log(this.transactions);
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },
    formatTimestampDate(timestamp) {
      const date = new Date(timestamp * 1000);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    getProcessingName(processing) {
      const processingCopy = Object.assign({}, processing); // proxy object
      return processingCopy.name;
    },
    submitSearch() {
      this.$inertia.get('/transactions/', {
        transactionId: this.search.transactionId,
        orderRef: this.search.orderRef,
        sortFields: this.search.sortFields,
        sortDirections: this.search.sortDirections,
        processing_id: this.search.processing_id,
        processingName: this.search.processing_name,
      });
    },
    isSortedBy(field) {
      return this.search.sortFields.includes(field);
    },
    getSortDirection(field) {
      const index = this.search.sortFields.indexOf(field);
      return index >= 0 ? this.search.sortDirections[index] : null;
    },
    setSort(field) {
      const index = this.search.sortFields.indexOf(field);
      if (index >= 0) {
        this.search.sortDirections[index] = this.search.sortDirections[index] === 'asc' ? 'desc' : 'asc';
      } else {
        this.search.sortFields.push(field);
        this.search.sortDirections.push('asc');
      }
      this.submitSearch();
    },
  }
}
</script>